import React from 'react'
import { processMediaUrl } from '../../_helpers/utils'
import { getInitials } from "../../_helpers/helpers";

function ChatCard({ handleChannelClick, data, activeChannel, showMobileConversation }) {
    if (!data || !data.channelId || !data.property) {
        return null
    }

    const imageSrc = data.property.picture ? processMediaUrl(data.property.picture) : '/user.png'

    const active = activeChannel && activeChannel.channelId === data.channelId

    return (
        <div
            onClick={() => {
                handleChannelClick(data.sid)
                // cssChangeClass()
            }}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                color: '#23426e',
                padding: '1rem',
                backgroundColor: active ? '#e6ebf5' : '',
                borderRadius: '0.25rem',
                transition: 'background-color 0.3s',
                backgroundColor: activeChannel && activeChannel.channel && data.sid == activeChannel.channel.sid ? '#e6ebf5' : '',
                fontWeight: data.sid == activeChannel && activeChannel.channel && activeChannel.channel.sid ? 'bold' : 'normal',
                // borderLeft: data.sid == activeChannel.channel.sid ? '4px solid #00796b' : 'none',
                margin: '0.5rem 0',
                padding: '0.5rem',
                borderRadius: '0.25rem',
                width: '100%',
                overflow: 'hidden',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    width: '100%',
                }}
            >
                <div
                    style={{
                        position: 'relative',
                        width: '2.75rem',
                    }}
                >
                    <img
                        alt=""
                        src={imageSrc}
                        onError={function({ currentTarget }) {
                            currentTarget.src = '/user.png'
                        }}
                        style={{
                            height: '2.75rem',
                            width: '2.75rem',
                            borderRadius: '9999px',
                            objectFit: 'cover',
                        }}
                    />
                    {/* Uncomment if online/offline indicators are needed
                    <span
                        style={{
                            bottom: '3px',
                            right: '3px',
                            height: '0.5rem',
                            width: '0.5rem',
                            display: 'block',
                            backgroundColor: userStatusForChannel ? 'rgb(6, 214, 160)' : 'rgb(255, 0, 0)',
                            borderRadius: '9999px',
                            border: '1px solid white',
                            position: 'absolute',
                        }}
                    ></span>
                    */}
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '85%',
                        position: 'relative',
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <p
                            className="minimal-name"
                            style={{
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                marginBottom: '0.25rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {data.property.name}
                        </p>

                        {data.lastMessageText && data.lastMessageDate && (
                            <p
                                style={{
                                    fontSize: '0.75rem',
                                    color: '#6b7280',
                                }}
                            >
                                {new Date(data.lastMessageDate).toLocaleTimeString([], {
                                    hour: 'numeric',
                                    minute: '2-digit',
                                    hour12: true,
                                })}
                            </p>
                        )}
                    </div>

                    {data.property.user && (
                        <p
                            style={{
                                fontSize: '0.75rem',
                                fontWeight: '500',
                                marginBottom: '0.25rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {getInitials(data.property.user)}
                        </p>
                    )}

                    {data.property.reservationId && (
                        <p
                            style={{
                                fontSize: '0.75rem',
                                fontWeight: '500',
                                marginBottom: '0.25rem',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {data.property.reservationId}
                        </p>
                    )}

                    {data.lastMessageText && (
                        <p
                            style={{
                                fontSize: '0.75rem',
                                color: '#6b7280',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: '250px',
                            }}
                        >
                            {data.lastMessageText}
                        </p>
                    )}

                    {Boolean(data.unreadMessagesCount) && (
                        <div
                            style={{
                                height: '1.5rem',
                                width: '1.5rem',
                                borderRadius: '9999px',
                                backgroundColor: '#c6d9f5',
                                fontSize: '0.75rem',
                                display: 'grid',
                                placeContent: 'center',
                                color: '#23426e',
                                fontWeight: '600',
                                position: 'absolute',
                                right: '0',
                                top: '1rem',
                                marginTop: '5px',
                            }}
                        >
                            {data.unreadMessagesCount}
                        </div>
                    )}

                    {/* {data.invited && (
                        <p
                            style={{
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                color: '#23426e',
                            }}
                        >
                            New invited
                        </p>
                    )} */}
                </div>
            </div>
        </div>
    )
}

export default ChatCard
